import { PayloadAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from './store';

export const useFastshiftDispatch = () => useDispatch<AppDispatch>();
export const useFastshiftSelector: TypedUseSelectorHook<RootState> = useSelector;
export type FastshiftDispatchPromise<T> = Promise<PayloadAction<T>> & {
	abort: (reason?: string | undefined) => void;
};
